import { gql, useQuery } from '@apollo/client';
import { useTranslation } from 'react-i18next';
import {
  ListNewsPostsInput,
  ListNewsPostsResponse,
  QueryListNewsPostsArgs,
} from 'apollo/generated/types';
import getApiLanguage from 'i18n/apiLanguage';

const LIST_NEWS_POSTS = gql`
  query listNewsPosts($input: ListNewsPostsInput!) {
    listNewsPosts(input: $input) {
      newsPosts {
        id
        title
        featured
        coverImage {
          id
          url
        }
      }
      count
    }
  }
`;
const useListNewsPostsQuery = (input?: ListNewsPostsInput) => {
  const { i18n } = useTranslation();

  return useQuery<{ listNewsPosts: ListNewsPostsResponse }, QueryListNewsPostsArgs>(
    LIST_NEWS_POSTS,
    {
      skip: !input,
      variables: input && {
        input: { ...input, language: getApiLanguage(i18n.language) },
      },
    }
  );
};
export default useListNewsPostsQuery;
